import cls from 'classnames';

import ITag from './types';
import useStyles from './styles';

function Tag({ children, color, className }: ITag) {
  const classes = useStyles(color);

  return <span className={cls(classes.root, className)}>{children}</span>;
}

export default Tag;
